export type TelegramUser = {
  id: number;
  first_name?: string;
  last_name?: string;
  username?: string;
  photo_url?: string;
  language_code?: string;
};

export function getTelegramWebApp(): any | null {
  return (window as any)?.Telegram?.WebApp ?? null;
}

export function getTelegramUser(): TelegramUser | null {
  const tg = getTelegramWebApp();
  const u = tg?.initDataUnsafe?.user;
  if (u?.id) return u as TelegramUser;
  try {
    const cached = localStorage.getItem('telegramUserCache');
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    if (parsed?.id) return parsed as TelegramUser;
  } catch {}
  return null;
}

export function getTelegramId(): number | null {
  const u = getTelegramUser();
  return typeof u?.id === 'number' ? u.id : null;
}

export function requestAuthRequired(detail?: { path?: string }) {
  try {
    window.dispatchEvent(new CustomEvent('aicams-auth-required', { detail: { path: detail?.path } }));
  } catch {
    // ignore
  }
}


